import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';

declare global {
  interface Window {
    __ls: (action: string, data: Record<string, unknown>, options?: Record<string, unknown>) => void;
  }
}

@Injectable({
  providedIn: 'root'
})
export class LiveSessionService {
  private platformId = inject<object>(PLATFORM_ID);
  isBrowser = isPlatformBrowser(this.platformId);

  newPageView(): void {
    if (this.isBrowser && typeof window.__ls === 'function') {
      try {
        window.__ls('newPageView', {});
      } catch (error) {
        console.error('Error tracking LiveSession page view:', error);
      }
    }
  }

  identifyUser(name: string, email: string, envName: string): void {
    if (this.isBrowser && typeof window.__ls === 'function') {
      try {
        window.__ls('identify', {
          name: name,
          email: email,
          params: {
            site: envName
          }
        });
      } catch (error) {
        console.error('Error identifying LiveSession user:', error);
      }
    }
  }
}
